import React, { Component } from 'react';
import { Card, Button, Popconfirm } from 'antd';
import { inject, observer } from 'mobx-react/index';
import { withRouter } from 'react-router-dom';

@withRouter
@inject('store')
@observer
export class DangerZoneSection extends Component {
    render() {
        return (
            <Card title={'Delete Bot'} bordered={false}>
                <p>
                    This will permanently delete all positions and remove the bot from your account.
                </p>

                <Popconfirm
                    title="Are you sure?"
                    onConfirm={() => {
                        this.props.store.botStore.removeBot();
                        this.props.history.push('/a/bots');
                    }}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type={'danger'}>Delete Bot</Button>
                </Popconfirm>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/DangerZone.js